import { create } from 'zustand';
import { RUNTIME_BACKEND_URL } from '../lib/backendUrl';
import { applyBrandColor } from '../lib/brandColors';

const API = `${RUNTIME_BACKEND_URL}/api/hesap`;
const DEFAULT_TITLE = 'Akıllı Çözüm Merkezi';

const setHeadLink = (rel, href) => {
  let el = document.querySelector(`link[rel="${rel}"]`);
  if (!el) {
    el = document.createElement('link');
    el.rel = rel;
    document.head.appendChild(el);
  }
  el.href = href;
};

const setMeta = (name, content) => {
  const el = document.querySelector(`meta[name="${name}"]`);
  if (el) el.setAttribute('content', content);
};

const applyHead = (title, logoUrl, brandColor) => {
  document.title = title;
  setMeta('apple-mobile-web-app-title', title);
  setMeta('theme-color', applyBrandColor(brandColor));
  const ver = (logoUrl.split('v=')[1] || '0');
  const icon = `${RUNTIME_BACKEND_URL}/api/hesap/branding/icon-192.png?v=${ver}`;
  setHeadLink('icon', icon);
  setHeadLink('apple-touch-icon', icon);
  setHeadLink('manifest', `/api/hesap/manifest.json?v=${ver}-${brandColor}`);
};

export const useHesapBranding = create((set) => ({
  title: DEFAULT_TITLE,
  logoUrl: '',
  settings: null,
  load: async () => {
    try {
      const d = await fetch(`${API}/site-settings`).then(r => r.json());
      const title = d.site_title || DEFAULT_TITLE;
      const logoUrl = d.logo_url ? `${RUNTIME_BACKEND_URL}${d.logo_url}` : '';
      set({ title, logoUrl, settings: d });
      applyHead(title, d.logo_url || '', d.brand_color || 'emerald');
    } catch { /* noop */ }
  },
  previewColor: (key) => applyBrandColor(key),
}));
